import Icon from "../../assets/images/description/Insert Page.svg";
import Icon2 from "../../assets/images/description/Edit File.svg";
import Icon3 from "../../assets/images/description/Restore Page.svg";
import styles from "./Description.module.scss";

export const Description = () => {

    const { section__description, wrapper__description, description__title, description__content, description__items, description__subtitle, description__list, description__item } = styles;

    return (
        <section className={section__description}>
            <div className={wrapper__description}>
                <h2 className={description__title}>
                    Dostępne usługi
                </h2>
                <ul className={description__content}>
                    <li className={description__items}>
                        <img src={Icon} alt="icon" />
                        <h3 className={description__subtitle}>
                            Tworzenie strony WWW
                        </h3>                            
                        <ul className={description__list}>
                            <li className={description__item}><h4>Zaplanowanie struktury strony</h4>decyzja o tym, jakie sekcje i podstrony będą potrzebne</li>
                            <li className={description__item}><h4>Projektowanie wyglądu strony</h4>dobranie odpowiedniej kolorystyki, czcionki i układu</li>
                            <li className={description__item}><h4>Tworzenie treści</h4>dodawanie tekstów, zdjęć, wideo i innych elementów multimedialnych</li>
                            <li className={description__item}><h4>Kodowanie</h4>implementacja strony za pomocą HTML, CSS i JavaScript</li>
                            <li className={description__item}><h4>Publikacja strony w internecie oraz jej monitorowanie</h4>sprawdzenie poprawności działania strony</li>
                        </ul>                        
                    </li>
                    <li className={description__items}>
                        <img src={Icon2} alt="icon" />
                        <h3 className={description__subtitle}>
                            Aktualizacja strony WWW
                        </h3>
                        <ul className={description__list}>
                            <li className={description__item}><h4>Aktualizacja treści</h4>dodawanie nowych artykułów, zdjęć, aktualizacja tekstów na stronie</li>
                            <li className={description__item}><h4>Poprawki w kodzie</h4>aktualizacja  frameworków, a także naprawa błędów lub poprawienie wydajności</li>
                            <li className={description__item}><h4>Poprawki bezpieczeństwa</h4>aktualizacja certyfikatów SSL, wtyczek czy usuwanie podatności</li>
                            <li className={description__item}><h4>Optymalizacja SEO</h4>poprawienie struktury linków, optymalizację meta-tagów i treści pod słowa kluczowe</li>
                            <li className={description__item}><h4>Optymalizacja wydajności</h4>poprawienie szybkości ładowania strony, kompresja obrazów, optymalizacja kodu</li>
                        </ul>
                    </li>
                    <li className={description__items}>
                        <img src={Icon3} alt="icon" />
                        <h3 className={description__subtitle}>
                            Odświeżenie strony WWW
                        </h3>
                        <ul className={description__list}>
                            <li className={description__item}><h4>Rewitalizacja designu</h4>zmiana kolorystyki, czcionek, układu strony, wprowadzenie nowych elementów wizualnych</li>
                            <li className={description__item}><h4>Nowoczesna technologia</h4>wdrożenie nowych technologii i trendów w projektowaniu stron</li>
                            <li className={description__item}><h4>Optymalizacja UX/UI</h4>poprawienie użyteczności strony, lepsze doświadczenia użytkownika</li>
                            <li className={description__item}><h4>Przyjazność mobilna</h4>dostosowanie strony do współczesnych urządzeń, takich jak smartfony i tablety</li>
                        </ul>
                    </li>
                </ul>
            </div>
        </section>
    )
}